import script from "./CarouselManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CarouselManager.vue?vue&type=script&setup=true&lang=js"

import "./CarouselManager.vue?vue&type=style&index=0&id=0345f0fe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0345f0fe"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinnerDots from 'quasar/src/components/spinner/QSpinnerDots.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSkeleton,QSelect,QImg,QSpinnerGears,QTooltip,QSpinnerDots,QDialog,QCard,QForm,QOptionGroup,QFile,QInput,QToggle,QField});
